import { isNull } from '@ricoh/ria.client.core/utils/data/object';

import type { SessionState } from './_state.type';

/** Session Reducer. */
export const sessionReducer = {
  /**
   * Start Session.
   *
   * @param {SessionState} state State.
   */
  session_start: (state: SessionState) => {
    state.session.startAt = Date.now();
  },

  /**
   * Stop Session.
   *
   * @param {SessionState} state State.
   */
  session_stop: (state: SessionState) => {
    state.session.startAt = undefined;
  },

  /**
   * Reset Session.
   *
   * @param {SessionState} state State.
   */
  session_reset: (state: SessionState) => {
    if (isNull(state.session.startAt)) {
      return;
    }

    state.session.startAt = Date.now();
  },
};
